import React from "react";
import { Row, Col, Typography } from "antd";
import 'antd/dist/antd.min.css';

const { Title } = Typography;

const TermsAndConditionsComponent = () => {
  return (
    <div style={{ width: "100%", padding: "40px 20px" }}>
      <Row>
        <Col md={4} xl={4}></Col>
        <Col md={16} xl={16}>
          <Title style={{ color: "#F6921E" }}>Terms and Conditions</Title>
          <p style={{ color: "#667085", fontSize: "16px" }}>
            Last updated: May 2026
          </p>
          <br />
          
          <Title level={3}>1. Acceptance of Terms</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            By accessing and using the ReadMark application, you accept and agree to be bound by the 
            terms and provisions of this agreement. If you do not agree to abide by these terms, 
            please do not use this service.
          </p>
          <br />

          <Title level={3}>2. User Account</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            You are responsible for maintaining the confidentiality of your account and password and 
            for restricting access to your account. You agree to accept responsibility for all activities 
            that occur under your account or password.
          </p>
          <br />

          <Title level={3}>3. Intellectual Property</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            The content, features, and functionality of the ReadMark application are owned by 
            Abhyaas Tech Labs and are protected by international copyright, trademark, and other 
            intellectual property laws.
          </p>
          <br />

          <Title level={3}>4. User Content</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            You retain ownership of any content you submit to the application. By submitting content, 
            you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and display 
            such content in connection with the service.
          </p>
          <br />

          <Title level={3}>5. Prohibited Activities</Title>
          <ul style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            <li>Use the application for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to the application</li>
            <li>Interfere with or disrupt the application or servers</li>
            <li>Transmit viruses or malicious code</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
          <br />

          <Title level={3}>6. Privacy Policy</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            Your use of the ReadMark application is also governed by our Privacy Policy, which can be 
            found at /privacy-policy. Please review our Privacy Policy, which also governs the application 
            and informs users of our data collection practices.
          </p>
          <br />

          <Title level={3}>7. Termination</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            We reserve the right to terminate or suspend your account and access to the application at 
            our sole discretion, without prior notice, for conduct that we believe violates these Terms 
            of Service or is harmful to other users, us, or third parties.
          </p>
          <br />

          <Title level={3}>8. Limitation of Liability</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            To the maximum extent permitted by law, ReadMark shall not be liable for any indirect, 
            incidental, special, consequential, or punitive damages, including without limitation, 
            loss of profits, data, use, goodwill, or other intangible losses.
          </p>
          <br />

          <Title level={3}>9. Governing Law</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            These Terms of Service and any separate agreements whereby we provide you services shall 
            be governed by and construed in accordance with the laws of India.
          </p>
          <br />

          <Title level={3}>10. Changes to Terms</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            We reserve the right to modify these terms at any time. We will notify users of any material 
            changes by posting the new Terms of Service on this page. Your continued use of the application 
            after such modifications constitutes your acceptance of the new Terms.
          </p>
          <br />

          <Title level={3}>11. Contact Us</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            If you have any questions about these Terms and Conditions, please contact us at:
            <br />
            <strong>Email:</strong> support@abhyaas.in
            <br />
            <strong>Phone:</strong> +91 83416 80090
          </p>
        </Col>
        <Col md={4} xl={4}></Col>
      </Row>
    </div>
  );
};

export default TermsAndConditionsComponent;
